import DateCard from "componentsv2/date/DateCardDouble";
import ToolButton from "componentsv2/button/ToolButton";
import IconButton from "componentsv2/button/IconButton";
import FilterTable from "componentsv2/table/FilterTable";
import SearchWidget from "componentsv2/widgets/SearchWidget";
import MenuReport from "componentsv2/menu/MenuReports";
import MenuWizard from "componentsv2/menu/wizard/MenuWizard";
import { useTable } from "storev2/tableStore";
import { SquaresPlusIcon, TableListIcon } from "components/Icons";
import { cn } from "tools/ui";

function TableToolbar(props) {
  const { layout, actions, handleView, storeId, data, kind, count, setView } =
    props;

  const { reload } = useTable();
  const buttons = [];

  async function handleSearch(value) {
    let dom;
    if (layout.filterDate) {
      dom = await layout.filterDate(value);
    }
    await reload(storeId, { date: dom ?? null });
  }

  if (layout.filterDate) {
    buttons.push(<DateCard key="filter-date" onChangeDate={handleSearch} />);
  }

  if (actions.includes("add")) {
    if (kind === "big") {
      buttons.push(
        <ToolButton
          key="add"
          action="add"
          label="button.add"
          handleAction={handleView}
        />,
      );
    } else {
      buttons.push(
        <IconButton
          key="add"
          name="add"
          action="add"
          label="button.add"
          onClick={handleView}
        />,
      );
    }
  }

  const activeSearch = props.activeSearch || layout.activeSearch;
  const countRecords = data ? data.length : 0;

  const searchables = [];
  for (const [field, attrs] of Object.entries(layout.fields)) {
    if (attrs.searchable) {
      searchables.push({
        name: field,
        type: attrs.type,
      });
    }
  }

  let reports;
  let wizards;
  if (layout.toolbar_table) {
    if (layout.toolbar_table.reports) {
      reports = layout.toolbar_table.reports;
    }
    if (layout.toolbar_table.wizards) {
      wizards = layout.toolbar_table.wizards;
    }
  }

  return (
    <div
      id="toolbar"
      className="flex max-md:flex-col max-md:gap-y-3 w-full justify-end md:justify-between"
    >
      <div className="flex flex-col md:flex-row md:space-x-4 gap-y-3 w-full md:w-auto">
        {layout.filters && (
          <FilterTable
            layout={layout}
            countRecords={countRecords}
            storeId={storeId}
          />
        )}

        {activeSearch && (
          <div className="w-full md:w-75 my-auto">
            <SearchWidget layout={layout} storeId={storeId} count={count} />
          </div>
        )}
      </div>
      <div className="flex space-x-2 items-center">
        {buttons && <div className="flex space-x-2">{buttons}</div>}
        {wizards && <MenuWizard wizards={wizards} />}
        {reports && <MenuReport reports={reports} />}
        {layout.availableViews?.length > 1 && (
          <div className="flex space-x-1 border-l border-gray-300 pl-2 ml-2">
            <button
              type="button"
              onClick={() => {
                setView.value = "list";
              }}
              className={cn(
                "w-12! h-10 flex items-center justify-center rounded-xl transition-colors border-none cursor-pointer",
                setView?.value === "list"
                  ? "bg-amber-100 ring-2 ring-amber-200"
                  : "bg-gray-200 hover:bg-gray-300",
              )}
            >
              <TableListIcon className="h-6 w-6" />
            </button>
            <button
              type="button"
              onClick={() => {
                setView.value = "column";
              }}
              className={cn(
                "w-12! h-10 flex items-center justify-center rounded-xl transition-colors border-none cursor-pointer",
                setView?.value === "column"
                  ? "bg-amber-100 ring-2 ring-amber-200"
                  : "bg-gray-200 hover:bg-gray-300",
              )}
            >
              <SquaresPlusIcon className="h-6 w-6" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default TableToolbar;
